<template>
  <v-dialog
    v-model="dialog"
    width="50%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="headline">Delete Folder Confirmation</v-card-title>
      <v-card-text>
        <v-container>
          <alert-message />
          {{
            item.totalFiles == 0
              ? `Are you sure will delete this folder "${item.name}"?`
              : `Are you sure you want to permanently delete this folder and everything in it?s`
          }}
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDelete">
          {{ item.totalFiles > 0 ? `No` : `Cancel` }}
        </v-btn>
        <v-btn class="error" text @click="deleteItemConfirm" :loading="loading">
          {{ item.totalFiles > 0 ? `Yes` : `Delete` }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage.vue";

export default {
  components: { AlertMessage },
  props: {
    item: Object,
    show: [Boolean, String],
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      currentItem: (state) => state.item,
      alert: (state) => state.alert,
    }),
  },
  watch: {
    show(n, o) {
      this.$store.dispatch("alert/clear");
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n) {
      if (!n) {
        this.closeDelete();
      }
    },
  },
  methods: {
    ...mapActions("storageFolder", ["delete"]),
    closeDelete() {
      this.dialog = false;
      this.$emit("onClosed");
    },
    async deleteItemConfirm() {
      this.loading = true;
      let item = {
        ...this.item,
        name: this.item.name || this.item.Name,
        id: this.item.id || this.item.Id,
      };
      await this.delete(item);
      if (!this.currentItem.status.error) {
        this.closeDelete();
        this.$emit("onSucceded");
      }
      this.loading = false;
    },
  },
};
</script>